import script from "./CreditsExchange.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsExchange.vue?vue&type=script&setup=true&lang=js"

import "./CreditsExchange.vue?vue&type=style&index=0&id=538682ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538682ce"]])

export default __exports__